// Firebase modüllerini içe aktar
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore"; // 🔥 bu satır eklendi
import { getAnalytics } from "firebase/analytics";


// Firebase ayarların
const firebaseConfig = {
  apiKey: "AIzaSyCTk37A4wEB1m5BdK9mD2N2RVa9ubSdM_k",
  authDomain: "bamor-shop.firebaseapp.com",
  projectId: "bamor-shop",
  storageBucket: "bamor-shop.firebasestorage.app",
  messagingSenderId: "774866502661",
  appId: "1:774866502661:web:c794396adf3520a968886c",
  measurementId: "G-R5MX8Q3CFC"
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// Firestore veritabanını dışa aktar
export const db = getFirestore(app);
export { app };


